import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import ProtectedRoute from "./components/pages/ProtectedRouter";
import UserAuthContextProvider from './contexts/UserAuthContext';
import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Aboutus from './components/pages/Aboutus';

import Storepage from './components/pages/Storepage';
import Login from './components/pages/Login';
import Signup from './components/pages/Signup';
import UserDashboard from './components/pages/UserDashboard';
import Eventpage from './components/pages/Eventpage';
import Contactus from './components/pages/Contactus';
import Productspage from './components/pages/Productspage';
import Applyfanchisee from './components/pages/Applyfanchisee';
import Profilepage from './components/pages/Profilepage';

import Careerpage from './components/pages/Careerpage';


function App() {
  return (
  
      <Router>
         <UserAuthContextProvider>
      <div>
        <Routes>
        <Route axact path="/" element={<Home/>}/>
        <Route axact path="/about-us" element={<Aboutus/>}/>
        <Route axact path="/Our-store" element={<Storepage/>}/>
        <Route axact path="/login" element={<Login/>} />

        <Route axact path="/gallery-and-event" element={<Eventpage/>} />
        <Route axact path="/contact-us" element={<Contactus/>} />
        <Route axact path="/products" element={<Productspage/>} />
        <Route axact path="/profile" element={<Profilepage/>} />
        <Route axact path="/careerpage" element={<Careerpage/>} />
        {/* <Route axact path="/menu" element={<Menupage/>} /> */}
        <Route axact path="/apply-franchisee" element={<Applyfanchisee/>} />
        <Route axact path="/signup-admin-cm-wb-krishnagar" element={<Signup />} />
        

        <Route axact path="/UserDashboard/:userId" element={<ProtectedRoute> <UserDashboard /> </ProtectedRoute>} />
        </Routes>
    <Footer/>
  
    </div>
    </UserAuthContextProvider>
    </Router>
  );
}

export default App;
